import { render, staticRenderFns } from "./common-tabbar.vue?vue&type=template&id=468f1af2&scoped=true"
import script from "./common-tabbar.vue?vue&type=script&lang=js"
export * from "./common-tabbar.vue?vue&type=script&lang=js"
import style0 from "./common-tabbar.vue?vue&type=style&index=0&id=468f1af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f1af2",
  null
  
)

export default component.exports